"use strict";

exports.__esModule = true;
var _UserActionSelector = require("./UserActionSelector");
Object.keys(_UserActionSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UserActionSelector[key]) return;
  exports[key] = _UserActionSelector[key];
});